import { isOutOfStock, normalizeStockQty } from '../cart/cartUtils';
import { productHasGiftTag } from '../productGiftTags';
import { productDiscountPercent, productOnSale } from '../productPricing';
import { normalizeProductCardBadges } from '../content/storefrontMerchandisingMerge';

/**
 * Resolve visual badges for product cards (grid + shelves).
 * @param {object} product
 * @param {object} storeCopy — site.store_copy
 * @returns {{ key: string, label: string, variant: string }[]}
 */
export function resolveProductCardBadges(product, storeCopy) {
  const cfg = normalizeProductCardBadges(storeCopy?.product_card_badges);
  const badges = [];

  if (cfg.show_sold_out && isOutOfStock(normalizeStockQty(product?.stock_qty))) {
    badges.push({ key: 'sold-out', label: 'Sold out', variant: 'muted' });
  }

  for (const row of cfg.tag_badges || []) {
    if (productHasGiftTag(product, row.tag)) {
      badges.push({
        key: `tag-${row.tag}`,
        label: row.label,
        variant: row.tag === 'bestseller' ? 'accent' : 'new',
      });
      break;
    }
  }

  if (cfg.show_sale_percent && productOnSale(product)) {
    const pct = productDiscountPercent(product);
    if (pct > 0) {
      badges.push({ key: 'sale', label: `${pct}% off`, variant: 'sale' });
    }
  }

  return badges;
}
